import HtmlEmbedDialog from './HtmlEmbedDialog'

export {
  buildEmbedHtml,
  parseEmbedFigure,
  safeSandbox,
  resolveEmbedDimensions,
  stripEmbedScripts,
  DEFAULTS,
} from './embedSerializer'
export default HtmlEmbedDialog
